import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedButtonComponent } from './shared-button/shared-button.component';
import { SectionWrapperComponent } from './section-wrapper/section-wrapper.component';
import { SharedCtaComponent } from './shared-cta/shared-cta.component';
import { ImageCardComponent } from './image-card/image-card.component';
import { InfoCardComponent } from './info-card/info-card.component';
import { AccordionComponent } from './accordion/accordion.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppendCurrencyPipe } from './pipes/append-currency.pipe';
import { UniqueVariantTypesPipe } from './pipes/unique-variant-types.pipe';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { SharedModalComponent } from './shared-modal/shared-modal.component';
import { ProductPreviewPopupComponent } from './product-preview-popup/product-preview-popup.component';
import { DesktopGalleryComponent } from './desktop-gallery/desktop-gallery.component';
import { ProductPricingComponent } from './product-pricing/product-pricing.component';
import { ProductActionsComponent } from './product-actions/product-actions.component';
import { ProductVariantComponent } from './product-variant/product-variant.component';
import { QuotationRequestFormComponent } from './quotation-request-form/quotation-request-form.component';
import { RouterModule } from '@angular/router';
import { WatchlistButtonComponent } from '../../shared/components/watchlist-button/watchlist-button.component';
import { OptimizedImageComponent } from '../../shared/components/optimized-image/optimized-image.component';
import { DownloadSelectionModalComponent } from './download-selection-modal/download-selection-modal.component';
import { VolumeDiscountComponent } from './volume-discount/volume-discount.component';
import { SafePipe } from '../../shared/pipes/safe.pipe';
import { FileSizePipe } from '../../shared/pipes/file-size.pipe';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@NgModule({
  declarations: [
    SharedButtonComponent,
    SectionWrapperComponent,
    SharedCtaComponent,
    ImageCardComponent,
    InfoCardComponent,
    AccordionComponent,
    AccordionItemComponent,
    AppendCurrencyPipe,
    UniqueVariantTypesPipe,
    IconButtonComponent,
    SharedModalComponent,
    ProductPreviewPopupComponent,
    DesktopGalleryComponent,
    ProductPricingComponent,
    ProductActionsComponent,
    ProductVariantComponent,
    QuotationRequestFormComponent,
    OptimizedImageComponent,
    DownloadSelectionModalComponent,
    VolumeDiscountComponent,
    FileSizePipe,
  ],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CarouselModule, RouterModule, WatchlistButtonComponent, SafePipe, TranslatePipe],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedButtonComponent,
    SectionWrapperComponent,
    SharedCtaComponent,
    ImageCardComponent,
    InfoCardComponent,
    AccordionComponent,
    AccordionItemComponent,
    AppendCurrencyPipe,
    UniqueVariantTypesPipe,
    IconButtonComponent,
    SharedModalComponent,
    ProductPreviewPopupComponent,
    DesktopGalleryComponent,
    ProductPricingComponent,
    ProductActionsComponent,
    ProductVariantComponent,
    QuotationRequestFormComponent,
    OptimizedImageComponent,
    DownloadSelectionModalComponent,
    VolumeDiscountComponent,
    FileSizePipe,
    TranslatePipe,
  ],
})
export class SharedModule { }
